import { useCallback, useRef } from 'react'

import { EMPTY_STRING } from '../../../constants/common'
import { isValueFunctionType } from '../../../utils/common'

export function useTextareaClearHandler({ forwardedRef, onBlur, onChange }) {
  const textareaRef = useRef(null)

  /*
   * Callback ref that synchronises the local textareaRef (used by
   * handleClear) and the caller's forwarded ref. Mutating refs from a
   * ref-attach callback is the canonical pattern; the compiler-rule
   * flags it because it does not distinguish ref-attach callbacks from
   * other useCallback bodies.
   */
  /* eslint-disable react-hooks/immutability */
  const setTextareaRef = useCallback(
    node => {
      textareaRef.current = node

      if (isValueFunctionType(forwardedRef)) {
        forwardedRef(node)
      } else if (forwardedRef) {
        forwardedRef.current = node
      }
    },
    [forwardedRef]
  )
  /* eslint-enable react-hooks/immutability */

  function handleClear() {
    onChange?.(EMPTY_STRING)

    onBlur?.()

    if (textareaRef.current) {
      textareaRef.current.value = EMPTY_STRING
    }
  }

  return { handleClear, textareaRef: setTextareaRef }
}
